import { Box, styled } from "@material-ui/core";
import { memo, useState } from "react";
import {
  EPOCUS_BORDER,
  EPOCUS_PRIMARY,
  EPOCUS_SYNCED_BG,
  EPOCUS_SYNCED_TEXT,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  rem,
} from "../../../_lib/epocus-palette";
import { CheckIcon } from "./icons";

const Card = styled(Box)({
  backgroundColor: EPOCUS_SYNCED_BG,
  border: `1px solid ${EPOCUS_BORDER}`,
  borderRadius: 14,
  padding: 14,
  display: "flex",
  flexDirection: "column",
  gap: 8,
});

const Title = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontSize: rem(12),
  fontWeight: 700,
  color: EPOCUS_SYNCED_TEXT,
});

const Code = styled("code")({
  fontFamily: "monospace",
  fontSize: rem(20),
  fontWeight: 700,
  letterSpacing: "0.06em",
  color: EPOCUS_TEXT_PRIMARY,
});

const Row = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 10,
  flexWrap: "wrap",
});

const CopyButton = styled("button")({
  minHeight: 44,
  padding: "0 10px",
  border: "none",
  background: "none",
  font: "inherit",
  fontSize: rem(12),
  fontWeight: 600,
  color: EPOCUS_PRIMARY,
  cursor: "pointer",
});

const Caption = styled("p")({
  margin: 0,
  fontSize: rem(12),
  lineHeight: 1.5,
  color: EPOCUS_TEXT_SECONDARY,
});

export const HandoverCard = memo<{ name: string; code: string }>(
  ({ name, code }) => {
    const [copied, setCopied] = useState(false);

    const copy = async () => {
      try {
        await navigator.clipboard.writeText(code);
        setCopied(true);
      } catch {
        setCopied(false);
      }
    };

    return (
      <Card>
        <Title>
          <CheckIcon size={13} />
          {`${name} created`}
        </Title>
        <Row>
          <Code>{code}</Code>
          <CopyButton type="button" onClick={() => void copy()}>
            {copied ? "Copied" : "Copy"}
          </CopyButton>
        </Row>
        <Caption>
          This is the code your device sends to. Someone at the site sets it on
          the ultrasound machine or vendor console.
        </Caption>
      </Card>
    );
  },
);
HandoverCard.displayName = "HandoverCard";
